// @ts-nocheck
import { getStoreConfig } from 'config'
import { deepValue } from '@corratech/pylot-utils'
import { useRouter } from 'next/router'

const config = getStoreConfig()

const getPylotBaseUrl = () => {
    const configBaseUrl = deepValue(config, ['base', 'url', 'baseUrl'], '')
    if (configBaseUrl) {
        return configBaseUrl.replace(/\/$/, '')
    }
    if (typeof window !== 'undefined') {
        return window.location.origin.replace(/\/$/, '')
    }
    return ''
}

/**
 * create Pylot format link
 * @param {string} link
 * @param {product / category / page} linkType
 */
const buildPylotLink = (link, linkType) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const router = useRouter()
    const pylotBaseUrl = getPylotBaseUrl()
    const urlObj = new URL(link, pylotBaseUrl)
    let pathname
    if (urlObj.pathname.includes(`/${router.locale}/`)) {
        const localeExp = new RegExp(`/${router.locale}/`, 'i')
        pathname = urlObj.pathname.replace(localeExp, '')
    } else {
        pathname = urlObj.pathname
    }
    const extension = /.html/i
    const slugEnding = `${pathname}${urlObj.search}`.replace(extension, '')
    const productDirectoryUrl =
        config?.base?.url?.model?.product?.directory ?? 'product'
    const categoryDirectoryUrl =
        config?.base?.url?.model?.category?.directory ?? 'category'
    const contentDirectoryUrl =
        config?.base?.url?.model?.cmsPage?.directory ?? 'content'
    let slug

    switch (linkType) {
        case 'product':
            slug = `/${productDirectoryUrl}${slugEnding}`
            break
        case 'category':
            slug = `/${categoryDirectoryUrl}${slugEnding}`
            break
        case 'page':
            slug = `/${contentDirectoryUrl}${slugEnding}`
            break
        default:
            slug = slugEnding
    }

    if (urlObj.pathname.includes(`/${router.locale}/`)) {
        return `/${router.locale}${slug}`
    }

    return slug.startsWith('/') ? slug : `/${slug}`
}
/**
 * Resolve link properties
 *
 * @param {string} link
 * @param {string} linkType
 */
const linkResolver = (link, linkType) => {
    const linkProps = {}
    const pylotBaseUrl = getPylotBaseUrl()
    const magentoUrl = deepValue(config, ['base', 'url', 'magentoBaseUrl'], '')
    const baseUrl = deepValue(config, ['base', 'url', 'baseUrl'], '')

    try {
        const backendUrlObj = magentoUrl ? new URL(magentoUrl) : ''
        const pylotUrlObj = new URL(pylotBaseUrl)
        const baseUrlObj = new URL(baseUrl)
        const urlObj = new URL(link, pylotBaseUrl)
        const isExternalUrl =
            urlObj.host !== pylotUrlObj.host &&
            urlObj.host !== backendUrlObj.host &&
            urlObj.host !== baseUrlObj.host

        if (isExternalUrl) {
            linkProps['href'] =
                linkType != 'default' ? buildPylotLink(link, linkType) : link
        } else {
            linkProps['to'] = buildPylotLink(link, linkType)
            linkProps['href'] = linkProps['to']
        }
    } catch (e) {
        console.log(e)
    }

    return linkProps
}

export default linkResolver
